<template>
  <with-actions>
    <form id="create-form" novalidate="novalidate">
      <div class="row">
        <div class="col-md-2 text-right">
          <h6 class="underline">{{ 'account' | t | titlecase }}</h6>
        </div>
        <div class="col-md-8">
          <div class="alert alert-warning mb-3" v-if="super_access">
            Warning: This staff user has access to view all customers across all organizations.
          </div>
          <div class="alert alert-warning mb-3" v-if="can_edit_subscriptions">
            Warning: This staff user has access to edit customers and customer subscriptions (including prices)
          </div>
          <div class="card mb-5">
            <div class="card-body">
              <div class="form-group">
                <label>{{ 'first_name' | t }}</label>
                <input class="form-control" v-model="current_staff.first_name" />
              </div>
              <div class="form-group">
                <label>{{ 'last_name' | t }}</label>
                <input class="form-control" v-model="current_staff.last_name" />
              </div>
              <div class="form-group">
                <label>{{ 'email' | t }}</label>
                <input class="form-control" v-model="current_staff.email" />
              </div>
              <div class="form-group">
                <label>{{ 'phone' | t }}</label>
                <input class="form-control" v-model="current_staff.phone" />
              </div>
              <div class="form-group">
                <label>{{ 'slack_id' | t }}</label>
                <input class="form-control" v-model="current_staff.slack_id" />
              </div>
              <div class="form-group">
                <label>{{ 'password' | t }}</label>
                <input class="form-control" v-model="current_staff.password" type="password" />
              </div>
              <div class="form-group">
                <label>{{ 'password_repeat' | t }}</label>
                <input class="form-control" type="password" ref="password_repeat" />
              </div>
              <div class="form-group">
                <label>{{ 'user_group' | t }}</label>
                <select class="form-control" v-model="current_staff.user_group">
                  <option></option>
                  <option v-for="user_group in user_groups" :value="user_group">{{ user_group.name }}</option>
                </select>
              </div>
              <div class="form-group" v-if="staff.user_group.scopes.includes('admin')">
                <label>{{ 'organizations' | t }}</label>
                <select class="form-control" v-model="current_staff.organization">
                  <option></option>
                  <option v-for="organization in organizations" :value="organization">{{ organization.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="can('write_staffs')">
        <div class="col-md-2 text-right"></div>
        <div class="col-md-8">
          <button class="btn btn-success btn-lg" @click="save($event)" :disabled="!valid">
            {{ (current_staff.id ? 'update_staff' : 'create_staff') | t }}
          </button>
        </div>
      </div>
    </form>
  </with-actions>
</template><script>
import _ from 'lodash';
import Vue from 'vue';
import Api from '@/store/jsonapi';
import Alerts from '@/utils/alerts';
import moment from 'moment-es6';
import $ from 'jquery';

export default {
  data: function () {
    return {
      errors: [],
      current_staff: this.value,
      user_groups: [],
      organizations: []
    };
  },
  async mounted() {
    ({ data: this.user_groups } = await Api.findAll('user_groups'));
    ({ data: this.organizations } = await Api.findAll('organizations'));
  },
  props: ['value'],
  computed: {
    super_access() {
      if (this.current_staff.user_group) {
        return _.includes(this.current_staff.user_group.scopes, 'read_organizations');
      }

      return false;
    },
    can_edit_subscriptions() {
      if (this.current_staff.user_group) {
        return _.includes(this.current_staff.user_group.scopes, 'write_subscriptions');
      }

      return false;
    }
  },
  methods: {
    save: function (event) {
      $(event.target).loading();

      if (this.current_staff && this.current_staff.id) {
        Api.update('staffs', this.current_staff)
          .then(({ data, errors, meta, links }) => {
            this.$router.push({ name: 'staffs' });
            $(event.target).loading(false);
          })
          .catch(({ errors }) => {
            $(event.target).loading(false);

            for (var i = 0; i < errors.length; i++) {
              Alerts.danger(errors[i]);
            }
          });
      } else {
        Api.create('staffs', this.current_staff)
          .then(({ data, errors, meta, links }) => {
            this.$router.push({ name: 'staffs' });
            $(event.target).loading(false);
          })
          .catch(({ errors }) => {
            $(event.target).loading(false);

            for (var i = 0; i < errors.length; i++) {
              Alerts.danger(errors[i]);
            }
          });
      }
    },
    valid: function () {
      return this.$refs.password_repeat == this.staff.password;
    }
  },
  asyncComputed: {}
};
</script>
